import { z } from "zod/v4";
import { baseDESchema, addPaymentValidationWithCondicionRequired, pagoSchema } from "./base-de-schema";

function addB2GValidation<T extends z.ZodTypeAny>(schema: T) {
    return schema.superRefine((data: any, ctx) => {
        if (!data.esB2G) return;

        if (data.dModCont && data.dModCont.trim().length !== 2)
            ctx.addIssue({ code: "custom", message: "Modalidad debe tener exactamente 2 caracteres", path: ["dModCont"] });

        if (data.dEntCont && !/^\d{1,5}$/.test(data.dEntCont.toString().trim()))
            ctx.addIssue({ code: "custom", message: "Hasta 5 dígitos numéricos", path: ["dEntCont"] });

        if (data.dAnoCont && !/^\d{2}$/.test(data.dAnoCont.toString().trim()))
            ctx.addIssue({ code: "custom", message: "Exactamente 2 dígitos", path: ["dAnoCont"] });

        if (data.dSecCont && !/^\d{1,7}$/.test(data.dSecCont.toString().trim()))
            ctx.addIssue({ code: "custom", message: "Secuencia debe ser un número de hasta 7 dígitos", path: ["dSecCont"] });

        if (data.items && data.items.length > 0) {
            data.items.forEach((item: any, index: number) => {
                const num = index + 1;
                if (item.dDncpG && item.dDncpG.trim().length !== 8)
                    ctx.addIssue({ code: "custom", message: `Ítem ${num}: Código DNCP General debe tener exactamente 8 caracteres`, path: ["items"] });

                if (item.dDncpE && (item.dDncpE.trim().length < 3 || item.dDncpE.trim().length > 4))
                    ctx.addIssue({ code: "custom", message: `Ítem ${num}: Código DNCP Específico debe tener entre 3 y 4 caracteres`, path: ["items"] });
            });
        }
    });
}

//Schema Factura Electrónica (iTiDE = 1)
export const facturaElectronicaFormSchema = addPaymentValidationWithCondicionRequired(
    addB2GValidation(
        baseDESchema.extend({
            pagos: z.array(pagoSchema).optional().default([{ tipoPago: "efectivo", monto: 0 }]),
            indicadorPresencia: z.enum(["1", "2", "4", "9"]).default("1"), // iIndPres
            // Flag B2G - se activa cuando el cliente tiene tipoOperacion B2G
            esB2G: z.boolean().default(false),
            // E1.1. Campos de informaciones de Compras Públicas (E020-E025)
            dModCont: z.string().optional(),                               // E021 - Modalidad (2 chars)
            dEntCont: z.string().optional(),                               // E022 - Entidad (hasta 5 dígitos)
            dAnoCont: z.string().optional(),                               // E023 - Año (2 dígitos)
            dSecCont: z.string().optional(),                               // E024 - Secuencia (hasta 7 dígitos)
            dFeCodCont: z.string().or(z.date()).nullable().optional().default(null), // E025 - Fecha AAAA-MM-DD
        })
    )
);

export type FacturaElectronicaFormData = z.infer<typeof facturaElectronicaFormSchema>;
